"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = [{
  "disciplines_cleaned": "Automatique",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "+ de 20 ans",
  "nbre": 3,
  "tjm_moyen": 649
}, {
  "disciplines_cleaned": "Automatique",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "11 à 20 ans",
  "nbre": 4,
  "tjm_moyen": 541
}, {
  "disciplines_cleaned": "Automatique",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "2 à 5 ans",
  "nbre": "",
  "tjm_moyen": 437
}, {
  "disciplines_cleaned": "Automatique",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "6 à 10 ans",
  "nbre": 3,
  "tjm_moyen": 486
}, {
  "disciplines_cleaned": "Automatique",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "Moins de 2 ans",
  "nbre": "",
  "tjm_moyen": 367
}, {
  "disciplines_cleaned": "Aéronautique / Aérospatial",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "+ de 20 ans",
  "nbre": 5,
  "tjm_moyen": 748
}, {
  "disciplines_cleaned": "Aéronautique / Aérospatial",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "11 à 20 ans",
  "nbre": "",
  "tjm_moyen": 680
}, {
  "disciplines_cleaned": "Aéronautique / Aérospatial",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "2 à 5 ans",
  "nbre": "",
  "tjm_moyen": 557
}, {
  "disciplines_cleaned": "Aéronautique / Aérospatial",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "6 à 10 ans",
  "nbre": 4,
  "tjm_moyen": 612
}, {
  "disciplines_cleaned": "Aéronautique / Aérospatial",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "Moins de 2 ans",
  "nbre": "",
  "tjm_moyen": 451
}, {
  "disciplines_cleaned": "Génie civil",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "+ de 20 ans",
  "nbre": 4,
  "tjm_moyen": 771
}, {
  "disciplines_cleaned": "Génie civil",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "11 à 20 ans",
  "nbre": 3,
  "tjm_moyen": 655
}, {
  "disciplines_cleaned": "Génie civil",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "2 à 5 ans",
  "nbre": 2,
  "tjm_moyen": 530
}, {
  "disciplines_cleaned": "Génie civil",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "6 à 10 ans",
  "nbre": "",
  "tjm_moyen": 589
}, {
  "disciplines_cleaned": "Génie civil",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "Moins de 2 ans",
  "nbre": "",
  "tjm_moyen": 403
}, {
  "disciplines_cleaned": "Génie mécanique",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "+ de 20 ans",
  "nbre": 9,
  "tjm_moyen": 719
}, {
  "disciplines_cleaned": "Génie mécanique",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "11 à 20 ans",
  "nbre": 9,
  "tjm_moyen": 529
}, {
  "disciplines_cleaned": "Génie mécanique",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "2 à 5 ans",
  "nbre": "",
  "tjm_moyen": 347
}, {
  "disciplines_cleaned": "Génie mécanique",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "6 à 10 ans",
  "nbre": 5,
  "tjm_moyen": 391
}, {
  "disciplines_cleaned": "Génie mécanique",
  "poste_cleaned": "Ingénieur (Directeur de projet, chargé d'études, etc)",
  "experience_pro": "Moins de 2 ans",
  "nbre": "",
  "tjm_moyen": 278
}, {
  "disciplines_cleaned": "Génie civil",
  "poste_cleaned": "Projeteur",
  "experience_pro": "+ de 20 ans",
  "nbre": "",
  "tjm_moyen": 518
}, {
  "disciplines_cleaned": "Génie civil",
  "poste_cleaned": "Projeteur",
  "experience_pro": "11 à 20 ans",
  "nbre": 3,
  "tjm_moyen": 478
}, {
  "disciplines_cleaned": "Génie civil",
  "poste_cleaned": "Projeteur",
  "experience_pro": "2 à 5 ans",
  "nbre": "",
  "tjm_moyen": 392
}, {
  "disciplines_cleaned": "Génie civil",
  "poste_cleaned": "Projeteur",
  "experience_pro": "6 à 10 ans",
  "nbre": "",
  "tjm_moyen": 379.47
}, {
  "disciplines_cleaned": "Génie civil",
  "poste_cleaned": "Projeteur",
  "experience_pro": "Moins de 2 ans",
  "nbre": "",
  "tjm_moyen": 436
}, {
  "disciplines_cleaned": "Génie mécanique",
  "poste_cleaned": "Projeteur",
  "experience_pro": "+ de 20 ans",
  "nbre": 6,
  "tjm_moyen": 530
}, {
  "disciplines_cleaned": "Génie mécanique",
  "poste_cleaned": "Projeteur",
  "experience_pro": "11 à 20 ans",
  "nbre": "",
  "tjm_moyen": 457
}, {
  "disciplines_cleaned": "Génie mécanique",
  "poste_cleaned": "Projeteur",
  "experience_pro": "2 à 5 ans",
  "nbre": "",
  "tjm_moyen": 325
}, {
  "disciplines_cleaned": "Génie mécanique",
  "poste_cleaned": "Projeteur",
  "experience_pro": "6 à 10 ans",
  "nbre": "",
  "tjm_moyen": 388
}, {
  "disciplines_cleaned": "Génie mécanique",
  "poste_cleaned": "Projeteur",
  "experience_pro": "Moins de 2 ans",
  "nbre": "",
  "tjm_moyen": 267
}];
exports["default"] = _default;